// extracted by mini-css-extract-plugin
export default {"logo_container":"Logo_logo_container__yNtjc","logo":"Logo_logo__vDBPO","logo_text":"Logo_logo_text__wdIX1"};